import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";

const WhatYouGetSection = (props) => {
  const items = [
    {
      title: "Full Access to Recordings",
      description:
        "Revisit every masterclass, keynote, and panel on your own time — so the learning never stops. Watch, rewind, and implement proven financial strategies anytime you need clarity or inspiration.",
      icon: "flaticon-play-button",
      bgColor: "linear-gradient(135deg, #6A82FB 0%, #4A63D8 100%)",
    },
    {
      title: "Cash Flow Templates & Workbooks",
      description:
        "Get access to plug-and-play financial templates designed by industry experts. These ready-to-use tools will help you track, plan, and grow your cash flow with confidence from day one.",
      icon: "flaticon-book",
      bgColor: "linear-gradient(135deg, #F7971E 0%, #FFD200 100%)",
    },
    {
      title: "Private Growth Community Access",
      description:
        "Join a vibrant network of ambitious entrepreneurs and wealth builders. Exchange ideas, find mentors, and stay connected with achievers who are redefining financial success.",
      icon: "flaticon-family",
      bgColor: "linear-gradient(135deg, #00C9FF 0%, #92FE9D 100%)",
    },
    {
      title: "Step-by-Step Implementation Guide",
      description:
        "No theory — just action. Receive a guided roadmap that walks you through applying every strategy directly in your business to create consistent, predictable cash flow.",
      icon: "flaticon-graduation-cap",
      bgColor: "linear-gradient(135deg, #FF6A88 0%, #FF99AC 100%)",
    },
    {
      title: "Lifetime Learning & Continuous Growth",
      description:
        "Your journey doesn't end with the summit. Enjoy lifetime access to exclusive webinars, future updates, and advanced resources to keep your financial growth on autopilot.",
      icon: "flaticon-badge",
      bgColor: "linear-gradient(135deg, #7F00FF 0%, #E100FF 100%)",
    },
  ];

  return (
    <section
      className={"section-padding " + (props.hclass || "")}
      style={{ background: "#252686" }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="What You’ll Get After the Summit"
              subtitle=""
              paragarap="Your growth doesn’t stop when the event ends. Every attendee receives:"
              titleStyle={{ color: "#FFFFFF" }}
              paragraphStyle={{ color: "#FFFFFF" }}
            />
          </div>
        </div>

        <div className="row justify-content-center">
          {items.map((item, idx) => (
            <div
              className="col col-xl-4 col-lg-6 col-md-6 col-12"
              key={idx}
              style={{ marginBottom: 30, display: "flex" }}
           >
              <div
                className="what-you-get-card"
                style={{
                  width: "100%",
                  background: "rgba(255,255,255,0.08)",
                  borderRadius: 16,
                  border: "1px solid rgba(255,255,255,0.2)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                  padding: 24,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  gap: 12,
                  transition: "transform .2s ease, box-shadow .2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 12px 26px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: item.bgColor,
                      color: "#fff",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
                    }}
                  >
                    <i className={item.icon} style={{ fontSize: 20 }} />
                  </div>
                  <h3
                    style={{
                      fontSize: 18,
                      fontWeight: 800,
                      color: "#FFFFFF",
                      margin: 0,
                    }}
                  >
                    {item.title}
                  </h3>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: 1,
                    background: "rgba(255,255,255,0.2)",
                    margin: "6px 0 4px",
                  }}
                />
                <p style={{ margin: 0, color: "#FFFFFF", lineHeight: 1.7 }}>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYouGetSection;
